import { render } from "./radar.vue?vue&type=template&id=3a5bc023&scoped=true"
import script from "./radar.vue?vue&type=script&lang=js"
export * from "./radar.vue?vue&type=script&lang=js"

import "./radar.vue?vue&type=style&index=0&id=3a5bc023&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a5bc023"]])

export default __exports__